<template>
  <div class="content-main">
    <div class="price-bar flex-box">
      <div class="prices-btn flex-box">
        <img class="courier" src="https://static.huiyiji520.com/delivery-1739785309.png">
        <div class="pay-prices">
          <div class="goods-price">¥ <span class="num">8.5</span></div>
          <div class="delivery-price">预估配送费¥0</div>
        </div>
        <div class="origin-price">¥27.5</div>
      </div>
      <div class="pay-btn">提交订单</div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading, Popup, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Popup.name]: Popup
  },
  data(){
    return {
      mail: "",
      loading: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goHome(){
      this.$router.replace("/")
    },
    measureScreenSize(){
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      Dialog.confirm({
        title: '提醒',
        message: `screenWidth: ${htmlWidth}`
      })
      .then(() => {
        // on confirm
      })
      .catch(() => {
        // on cancel
      });
    }
  },
  mounted(){
    // this.measureScreenSize() ffd100
  }
}
</script>

<style scoped>
.price-bar{
  background-color:#000;font-size:28px;width:640px;height:100px;
  margin:0 auto;margin-top:100px;border-radius:50px;
  justify-content:space-between;
}
.prices-btn{
  color:#fff;
}
.prices-btn .courier{
  width:110px;height:110px;margin-left:40px;margin-right:20px;
  position:relative;bottom:15px;
}
.prices-btn .pay-prices{margin-right:40px;}
.prices-btn .pay-prices .goods-price{text-align:left;}
.prices-btn .pay-prices .goods-price .num{font-size:40px;font-weight:bold;}
.prices-btn .pay-prices .delivery-price{font-size:22px;}
.prices-btn .origin-price{text-decoration:line-through;}
.pay-btn{
  background:#ffd100;height:100%;width:140px;line-height:100px;
  border-top-right-radius:50px;border-bottom-right-radius:50px;
}
</style>
